export const MEETING_TYPES = [
  { value: 'client_sync', label: 'Client Sync', titleTemplate: (client) => client ? `Sync with ${client}` : 'Client Sync' },
  { value: 'portfolio_review', label: 'Portfolio Review', titleTemplate: (client) => client ? `Portfolio Review — ${client}` : 'Portfolio Review' },
  { value: 'financial_plan', label: 'Financial Plan', titleTemplate: (client) => client ? `Financial Plan — ${client}` : 'Financial Plan Review' },
  { value: 'onboarding', label: 'Onboarding', titleTemplate: (client) => client ? `Onboarding — ${client}` : 'New Client Onboarding' },
  { value: 'quarterly_review', label: 'Quarterly Review', titleTemplate: (client) => client ? `Q${Math.ceil((new Date().getMonth() + 1) / 3)} Review — ${client}` : 'Quarterly Review' },
  { value: 'internal', label: 'Internal Meeting', titleTemplate: () => 'Internal Meeting' },
  { value: 'other', label: 'Other', titleTemplate: () => '' }
]

export const TERMINAL_STATUSES = ['completed', 'failed', 'cancelled']
